export function EuFlag(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="European Union" clipPath="url(#clip0_6850_193107)">
        <path
          id="Vector"
          d="M5 10C7.76142 10 10 7.76142 10 5C10 2.23858 7.76142 0 5 0C2.23858 0 0 2.23858 0 5C0 7.76142 2.23858 10 5 10Z"
          fill="#0052B4"
        />
        <g id="Group">
          <path
            id="Vector_2"
            d="M5.0002 1.95605L5.16209 2.45428H5.68592L5.26211 2.76219L5.424 3.26041L5.0002 2.95248L4.57637 3.26041L4.73826 2.76219L4.31445 2.45428H4.8383L5.0002 1.95605Z"
            fill="#FFDA44"
          />
          <path
            id="Vector_3"
            d="M2.84838 2.84742L3.31518 3.08523L3.68559 2.71484L3.60361 3.23223L4.07039 3.47006L3.55299 3.55201L3.47104 4.06943L3.2332 3.60266L2.71582 3.68463L3.08623 3.31422L2.84838 2.84742Z"
            fill="#FFDA44"
          />
          <path
            id="Vector_4"
            d="M1.95703 4.99922L2.45525 4.83732V4.31348L2.76314 4.7373L3.26139 4.57541L2.95344 4.99922L3.26139 5.42303L2.76314 5.26115L2.45525 5.68496V5.16111L1.95703 4.99922Z"
            fill="#FFDA44"
          />
          <path
            id="Vector_5"
            d="M2.84838 7.15168L3.08621 6.68488L2.71582 6.31447L3.23322 6.39647L3.47102 5.92969L3.55299 6.44709L4.07037 6.52904L3.60365 6.76688L3.68559 7.28426L3.31518 6.91385L2.84838 7.15168Z"
            fill="#FFDA44"
          />
          <path
            id="Vector_6"
            d="M5.0002 8.0426L4.83828 7.54437H4.31445L4.73828 7.23646L4.57637 6.73828L5.0002 7.04617L5.424 6.73828L5.26211 7.23646L5.68592 7.54437H5.16207L5.0002 8.0426Z"
            fill="#FFDA44"
          />
          <path
            id="Vector_7"
            d="M7.15264 7.15168L6.68586 6.91387L6.31543 7.28428L6.3974 6.76686L5.93066 6.52904L6.44805 6.44709L6.53 5.92969L6.76781 6.39647L7.28519 6.31447L6.91478 6.68492L7.15264 7.15168Z"
            fill="#FFDA44"
          />
          <path
            id="Vector_8"
            d="M8.04357 4.99922L7.54535 5.16111V5.68496L7.23744 5.26113L6.73926 5.42303L7.04717 4.99922L6.73926 4.57541L7.23746 4.7373L7.54535 4.31348V4.83734L8.04357 4.99922Z"
            fill="#FFDA44"
          />
          <path
            id="Vector_9"
            d="M7.15264 2.8474L6.9148 3.3142L7.28521 3.68461L6.76779 3.60262L6.53 4.06939L6.44805 3.55199L5.93066 3.47002L6.3974 3.23221L6.31543 2.71484L6.68588 3.08523L7.15264 2.8474Z"
            fill="#FFDA44"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_6850_193107">
          <rect width="10" height="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
